import langs from "@/assets/data/langs";

export default {
    install(Vue, options) {
        // 3. inject some component options
        // Vue.mixin({
        //     created() {}
        // });

        // 4. add an instance method
        Vue.prototype.$langs = langs;
        Vue.prototype.$langs.setLang = function () {
            // langs.lang = 'en';
        }
    }
}